import { registerStore } from '../../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.sider',
  initialState: {
    deferredPrompt: null,
    isTourOpen: false,
    isSidebarOpen: true,
    isNavigationOpen: false,
  },
});

export default store;
